<div class="InfoDetails">

        <div class="Loading" *ngIf="isShowLoading">
                <div class="loader"></div>
                <label class="loaderlabel">Please wait while Processing....</label>
        </div>


        <div class="row form-group hidden-sm hidden-xs">
                <div class="row bs-wizard TravleWizard" style="border-bottom:0;">

                        <div class="col-xs-4 bs-wizard-step complete">
                                <div class="text-center bs-wizard-stepnum">{{'Step 1'|translate}}</div>
                                <div class="progress">
                                        <div class="progress-bar"></div>
                                </div>
                                <a href="#" class="bs-wizard-dot"></a>
                                <div class="bs-wizard-info text-center">{{'Basic Info'|translate}}</div>
                        </div>

                        <div class="col-xs-4 bs-wizard-step " [ngClass]="!ReviewInfo?'complete':'active'">
                                <!-- complete -->
                                <div class="text-center bs-wizard-stepnum">{{'Step 2'|translate}}</div>
                                <div class="progress">
                                        <div class="progress-bar"></div>
                                </div>
                                <a href="#" class="bs-wizard-dot"></a>
                                <div class="bs-wizard-info text-center"> {{'Insured Details'|translate}}</div>
                        </div>

                        <div class="col-xs-4 bs-wizard-step " [ngClass]="ReviewInfo?'disabled':'complete'">
                                <!-- complete -->
                                <div class="text-center bs-wizard-stepnum">{{'Step 3'|translate}}</div>
                                <div class="progress">
                                        <div class="progress-bar"></div>
                                </div>
                                <a href="#" class="bs-wizard-dot"></a>
                                <div class="bs-wizard-info text-center"> {{'Review & Payment'|translate}}</div>
                        </div>


                </div>

        </div>

        <div class="row">

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                        <router-outlet></router-outlet>

                </div>




        </div>


</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelProposalForm/TravelProposalForm.html